<template>
  <base-layout :do-skip-header="false" :do-skip-pic="skipHeaderOnMobile" :doIncludeExtraContent="true" :doIncludeBgVideo="true">

    <template #main>
      <div class="hidden lg:block relative max-w-7xl mx-auto mt-6">
        <div v-if="lastRegistered" class="home-ticker-container bg-red-600 text-white text-sm whitespace-nowrap overflow-hidden cursor-pointer" @click="openEmail">
          <div class="home-ticker py-4 ">
            <span>{{ lastRegistered }}</span>
          </div>
        </div>
      </div>

      <div class="hidden sm:block text-center mt-10 text-md leading-7 text-gray-700">
        <h1 class="text-4xl text-bold">Connecting the IT Trading Industry</h1><br>
        <div class="text-left">
          Following a record breaking <strong>22nd European Broker Meeting in Vilamoura, Portugal, with 1,200 attendees from 585 companies</strong>, we are already looking forward to our next edition!
          <br><br>
          The <strong>23rd European Broker Meeting will take place on September 22, 23 & 24, 2027, at the Hilton Istanbul Bomonti Hotel & Conference Center in Istanbul, Turkey</strong>. Join us for three days of networking, valuable business connections, and exciting opportunities with IT traders from around the world.
          <br><br>
          <strong>Registration opens in January 2027!</strong>
          <br><br>
          <strong>The European Broker Meeting's Impact on IT4Kids</strong>
          <br>
          We are incredibly proud to announce that during the 22nd European Broker Meeting, we raised an amazing <strong>€40,000 for IT4Kids!</strong>
          <br>
          A huge thank you to everyone who contributed to this fantastic achievement!
          <br><br>
          <strong>See you in Istanbul in 2027!</strong>
          <br><br>
          <img class="block mx-auto" src="https://www.europeanbrokermeeting.com/images/ebm-homepage-turkiye.png" alt="EBM2027 in Istanbul, Turkey" >
          <!-- <template v-if="showDownloadSharingBanner">
            <br><br>
            <strong>WIN A FREE EBM2027 TICKET!</strong><br>
            Share your EBM2026 attendance on LinkedIn and get a chance to WIN 1 of 5 FREE EBM2027 tickets!
            <br>
            <a href="#" class="text-red-600 underline cursor-pointer" @click.prevent="downloadSharingBanner">Download</a> your personalized attendee banner and post it today.<br>
            <strong>See you in Portugal!</strong>
          </template> -->
        </div>
        <!-- <span v-html="homepageText"></span> -->
      </div>

      <!-- For small screens show the large buttons //-->
      <div class="block sm:hidden max-w-xs mx-auto mt-4">
        <pwa-install-banner />
      </div>
      <div v-if="!user" class="block sm:hidden">
        <!-- <img class="max-h-32 w-full object-contain" :src="mainSponsor.logoURL" :alt="mainSponsor.name"/> -->
        <div class="max-w-xs mx-auto text-xl">
          <div class="text-center mb-4">Let's get started!</div>
          
          <div class="grid grid-cols-2 gap-4">
            <div class="mainMenuButt" @click="goPage('program');">
              <img src="/images/program.png" class="mobileButton">
              <div class="text-center text-xl">Program</div>
            </div>
            <div class="mainMenuButt" @click="goPage('attendees');">
              <img src="/images/attendees.png" class="mobileButton">
              <div class="text-center text-xl">Attendees</div>
            </div>
            <div class="mainMenuButt" @click="goPage('testimonials');">
              <img src="/images/testimonials.png" class="mobileButton">
              <div class="text-center text-xl">Testimonials</div>
            </div>
            <!-- <div class="mainMenuButt" @click="goPage('waiting-list');"> -->
            <!-- <div class="mainMenuButt" @click="goPage('register');">
              <img src="/images/register.png" class="mobileButton">
              <div class="text-center text-xl">Register</div>
            </div> -->
            <div class="col-span-2 mt-8 text-sm text-center">Please sign in for more options</div>
          </div>
        </div>        
      </div>
      <div v-else class="block sm:hidden">
        <img v-if="mainSponsor" class="max-h-32 w-full object-contain" :src="mainSponsor.logoURL" :alt="mainSponsor.name"/>
        <div class="max-w-xs mx-auto text-xl">
          <div class="text-center mb-4">Let's get started, {{user.name}}!</div>
          
          <div class="grid grid-cols-2 gap-4">
            <div class="mainMenuButt" @click="goPage('scheduler');">
              <img src="/images/scheduler.png" class="mobileButton">
              <div class="text-center text-xl">Scheduler</div>
            </div>
            <div class="mainMenuButt" @click="goPage('program');">
              <img src="/images/program.png" class="mobileButton">
              <div class="text-center text-xl">Program</div>
            </div>
            <div class="mainMenuButt" @click="goPage('attendees');">
              <img src="/images/attendees.png" class="mobileButton">
              <div class="text-center text-xl">Attendees</div>
            </div>
            <div class="mainMenuButt" @click="goPage('scan');">
              <img src="/images/scan.png" class="mobileButton">
              <div class="text-center text-xl">Scan Lead</div>
            </div>

            <div class="col-span-2 mt-8 mx-auto bg-no-repeat bg-center bg-contain w-32 h-32">
               <!-- Google's QR code generation service is no longer actively maintained, switched to QR Server API for QR code generation //-->
              <img :src='"https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://www.europeanbrokermeeting.com/checkin?id=" + user.id'> 
            </div>
          </div>
        </div>
        <div v-if="nextMeeting && nextMeeting.details">
          <div class="text-center mt-8 font-bold text-lg">Next upcoming meeting</div>
          <div class="max-w-sm mx-auto bg-white rounded-xl shadow-md overflow-hidden mt-4" @click="toScheduler()">
            <div class="bg-green-600 text-white text-md font-semibold p-3">
              {{ nextMeeting.details?.start }} - {{ nextMeeting.details?.end }}
              |
              {{
                nextMeeting.details?.table > tables
                  ? 'HOTEL LOBBY'
                  : 'Table ' + nextMeeting.details?.table
              }}
            </div>

            <div v-if="nextMeeting.with" class="p-3 text-gray-700">
              <p class="text-lg font-black">{{ nextMeeting.with.name }}</p>
              <p class="text-sm">{{ nextMeeting.with.companyName }} | {{ nextMeeting.with.function }}</p>
              <a class="text-sm" href="">{{ nextMeeting.with.website }}</a><br>
              <a class="text-sm" href="">{{ nextMeeting.with.email }}</a>
            </div>

            <div class="flex flex-row-reverse items-center md:justify-end mb-3">
              <div v-for="(profile, index) in nextMeeting.contacts" :key="profile.id" 
                class="-mr-[10px] first:mr-2"
                :style="{ zIndex: profile.length - index }">
                <img 
                  class="rounded-full border-2 object-cover h-10 w-10 md:h-16 md:w-16 border-gray-200" 
                  :src="profile.profilePic" 
                  alt="Profile" 
                />
              </div>
            </div>
          </div>
        </div>
        <div v-show="captainsDinnerRegistrationStatus === 1" class="text-red-600 mt-6 text-center ">
          Reminder: You are registered for the Captain's Dinner on Thursday November 6 at 19:00
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";
import BaseLayout from "../components/BaseLayout.vue";
import PwaInstallBanner from "../components/PwaInstallBanner.vue";
import eventBus from "../utils/eventBus";

export default {
  name: "Home",
  components: {
    BaseLayout,
    PwaInstallBanner,
  },
  data() {
    return {
      isUserDropdownOpen: false,
      lastRegistered: null,
      homepageText: null,
      allSettings: null,
      skipHeaderOnMobile: true,
      sponsors: [],
      mainSponsor: null, 
      captainsDinnerRegistrationStatus: 0,
      nextMeeting: {
        details: null,
        with: null,
        contacts: []
      },
      tables: null
    };
  },
  watch: {
    user: {
      handler(newVal) {
        if (newVal) {
		      this.fetchCaptainsLunchSlotsTaken()
        }
      },
      deep: true,
      immediate: false
    },
  },
  mounted() {
    this.handleResize(); // Call once on mount to set initial state
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapState(["user"]),
    showDownloadSharingBanner() {
      return this.user
    },
  },
  methods: {
    ...mapActions(['getNextMeeting', 'getSharingBanner']),
    handleResize() {
      const isMobile = window.matchMedia("(max-width: 640px)").matches;
      this.skipHeaderOnMobile = isMobile;
    },
    goPage(page) {
      this.$router.push({ path: page })
    },
    async fetchNextMeeting() {
      if(this.user) {
        const res = await this.getNextMeeting()
        const meeting = res.data.meeting
        const contacts = res.data.contacts 
        if (!isNaN(Number(res.data.tables))) {
          this.tables = Number(res.data.tables)
        }
        if(meeting && contacts) {
          if (meeting.fromId === this.user.id) {
            this.nextMeeting.with = contacts.find(contact => contact.id == meeting.toId);
          } else {
            this.nextMeeting.with = contacts.find(contact => contact.id == meeting.fromId);
          }

          this.nextMeeting.contacts = contacts.map(contact => ({
            ...contact,
            profilePic: contact.profilePic || 
              'https://ui-avatars.com/api/?name=' + encodeURIComponent(contact.name) + '&background=fff&color=aaa'
          }));
          this.nextMeeting.details = meeting 
        }
      }
    } ,
    toScheduler() {
      this.$router.push({ name: 'scheduler' })
    },
    async fetchCaptainsLunchSlotsTaken() {
      try {
        const res = await this.$http.get("/api/misc/captLunchSlotsTaken");
        if(res.data.status === 200) {
          const data = res.data
          this.captainsDinnerRegistrationStatus = data.registrationStatus
        }
      } catch (err) {
        console.log("err", err)
      }
    },
    openEmail() {
      // window.open('mailto:sales@thebrokersite.com?subject=EBM Last minute availability')
    },
    async downloadSharingBanner() {
      const payload = {
        contactId: this.user.id,
        email: this.user.email,
        companyId: this.user.companyId
      }

      const resp = await this.getSharingBanner(payload);

      if (resp.data.status != 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: resp.data?.message,
          timeoutInMS: 5000,
        });
        return;
      }

      if (resp.data?.downloadPath) {
        let imageUrl = resp.data.downloadPath;

        imageUrl = imageUrl.replace(
          /^https?:\/\/(www\.)?europeanbrokermeeting\.com/i,
          window.location.origin
        );

        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = imageUrl.split("/").pop() || "sharing-banner.png";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
      }
    },
  },
  async created() {
    const sponsors = await this.$http.get("/api/misc/sponsors").then(res => res.data.payload)
    const sponsorDTOs = _.map(sponsors, sponsor => {
      return _.extend({}, sponsor, {
        logoURL: `${window.location.origin}/images/sponsors/${sponsor.logo}`,
        sponsorType: `${sponsor.type} Sponsor`
      })
    })
    this.mainSponsor = _.find(sponsorDTOs, {type: "main"})
    // this.sponsors = _.difference(sponsorDTOs, [this.mainSponsor])

    try {
      const names = await this.$http.get("/api/misc/lastRegistered").then(res => res.data.payload)

      // this.lastRegistered = `Latest registered attendees: \xA0 \xA0  ${names.join(" \xA0 \xA0 • \xA0 \xA0 ")}`
      // this.lastRegistered = `The European Broker Meeting is sold out! 1,000 traders from 40+ countries registered.`
      // this.lastRegistered = `Winners of the free #EBM2025 tickets: \xA0 \xA0  C&M IT Remarketing \xA0 \xA0 • \xA0 \xA0 Aucnet \xA0 \xA0 • \xA0 \xA0 Ecotech Solutions \xA0 \xA0 • \xA0 \xA0 Hibco General LLC \xA0 \xA0 • \xA0 \xA0 Rapid Solutions \xA0 \xA0 \xA0 \xA0 • \xA0 \xA0 \xA0 \xA0 At the 20th #EBM2024 we raised €25,000 for IT4Kids! \xA0 \xA0 \xA0 \xA0 • \xA0 \xA0 \xA0 \xA0 The 21st #EBM2025 will be held on November 5, 6 & 7 2025 in Dublin!`
    } catch (err) {
      console.log("err", err)
    }

    try {
      this.allSettings = await this.$http.get("/api/misc/allSettings").then(res => res.data.payload)
      this.homepageText = this.allSettings.mainpage_text
      // this.homepageText = await this.$http.get("/api/misc/allSettings").then(res => res.data.payload.mainpage_text)
    } catch (err) {
      console.log("err", err)
    }
    this.fetchNextMeeting()
    this.fetchCaptainsLunchSlotsTaken()
  }

};
</script>

<style scoped>
.home-hero-container {
  position: relative;
  width: 100%;
  padding-bottom: 28%;
  max-height: 400px;
  overflow: hidden;
}

.home-hero {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center 10%;
  z-index: 1
}

@-webkit-keyframes ticker {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(60%, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes ticker {
  0% {
    transform: translate3d(60%, 0, 0); /* Start just outside of the right edge */
  }
  100% {
    transform: translate3d(-100%, 0, 0); /* Move to twice the width to the left */
  }
}

.home-ticker-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 32px;
  z-index: 2;
}

.home-ticker {
  position: absolute;
  bottom: 0;
  height: 42px;
  z-index: 3;

  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: ticker;
  animation-name: ticker;
  -webkit-animation-duration: 30s;
  animation-duration: 30s;
}

.mainMenuButt {width: 139px; height: 139px; background-color: #e9e9e9; margin: 5px; padding: 5px;}
.mobileButton {
  width: 70px;
  height: 70px;
  margin: 15px auto 5px auto;
  background-size: contain;
  display: block;
}
</style>
